.root {
  --box-direction: row;
  --box-wrap: nowrap;
  --box-gap: 0;
  --box-align: stretch;
  --box-justify: flex-start;
  --box-padding: 0;

  display: flex;
  flex-direction: var(--box-direction);
  flex-wrap: var(--box-wrap);
  gap: var(--box-gap);
  align-items: var(--box-align);
  justify-content: var(--box-justify);
  padding: var(--box-padding);
}
